import $ from 'jquery';
import * as bootstrap from 'bootstrap';
import Inputmask from 'inputmask';
import 'inputmask/dist/jquery.inputmask.js';
import 'bootstrap-notify';

window.$ = window.jQuery = $;
window.bootstrap = bootstrap;
window.Inputmask = Inputmask;

if (!$.isFunction) {
    $.isFunction = function (obj) {
        return typeof obj === 'function';
    };
}

const normalizeModalAction = (instance, action) => {
    if (!action || action === 'show') {
        instance.show();
        return;
    }

    if (action === 'hide') {
        instance.hide();
        return;
    }

    if (action === 'toggle') {
        instance.toggle();
    }
};

$.fn.modal = function (actionOrOptions) {
    return this.each(function () {
        const instance = bootstrap.Modal.getOrCreateInstance(this, typeof actionOrOptions === 'object' ? actionOrOptions : {});
        normalizeModalAction(instance, actionOrOptions);
    });
};

$.fn.tooltip = function (options) {
    return this.each(function () {
        bootstrap.Tooltip.getOrCreateInstance(this, options || {});
    });
};
